import React from 'react'
import type { FC } from 'react'
import { StyledAlert, StyledTitle } from './styles'
import type { AlertProps } from './types'

//TBD: Update component once we have an actual design
const Alert: FC<AlertProps> = ({ title, body, severity = 'info', onClick, icon, titlePadding }) => (
  <StyledAlert
    severity={severity}
    onClick={onClick}
    showOnClick={Boolean(onClick)}
    icon={icon}
    titlePadding={titlePadding}
  >
    <StyledTitle>{title}</StyledTitle>
    {body}
  </StyledAlert>
)

export default Alert
